export default "__VITE_ASSET__55059df3__"